(function() {
  const lazyElements = {
    'overflow-list': '@theme/overflow-list',
    'quick-add-component': '@theme/quick-add',
    'quick-add-dialog': '@theme/quick-add',
    'cart-discount-component': '@theme/cart-discount',
    'dialog-component': '@theme/dialog',
    'variant-picker': '@theme/variant-picker',
    'product-card': '@theme/product-card',
    'product-card-link': '@theme/product-card',
    'swatches-variant-picker-component': '@theme/product-card',
    'product-form-component': '@theme/product-form',
    'add-to-cart-component': '@theme/product-form',
    'accordion-custom': '@theme/accordion-custom',
    'deferred-media': '@theme/media',
    'product-model': '@theme/media',
    'product-price': '@theme/product-price',
    'product-sku-component': '@theme/product-sku',
    'product-title': '@theme/product-title',
    'product-inventory': '@theme/product-inventory',
    'show-more-component': '@theme/show-more',
    'slideshow-component': '@theme/slideshow',
    'layered-slideshow-component': '@theme/layered-slideshow',
    'anchored-popover': '@theme/anchored-popover',
    'floating-panel-component': '@theme/floating-panel',
    'video-background-component': '@theme/video-background',
    'component-quantity-selector': '@theme/component-quantity-selector',
    'media-gallery': '@theme/media-gallery',
    'rte-formatter': '@theme/rte-formatter',
    'volume-pricing': '@theme/volume-pricing',
    'price-per-item': '@theme/price-per-item',
    'volume-pricing-info': '@theme/volume-pricing-info',
    'localization-form-component': '@theme/localization',
    'dropdown-localization-component': '@theme/localization',
    'drawer-localization-component': '@theme/localization',
    'fly-to-cart': '@theme/fly-to-cart',
    'sticky-add-to-cart': '@theme/sticky-add-to-cart'
  };

  const loadedModules = new Set();

  function checkAndLoad(node) {
    if (node.nodeType !== 1) return;
    const tagName = node.tagName.toLowerCase();
    const moduleName = lazyElements[tagName];
    if (moduleName && !customElements.get(tagName) && !loadedModules.has(moduleName)) {
      loadedModules.add(moduleName);
      import(moduleName).catch(err => console.error(`[LazyLoader] Failed to load ${moduleName} for <${tagName}>:`, err));
    }
  }

  const selector = Object.keys(lazyElements).join(',');

  function scan(root) {
    if (!root) return;
    if (root.matches && root.matches(selector)) {
      checkAndLoad(root);
    }
    if (root.querySelectorAll) {
      const elements = root.querySelectorAll(selector);
      for (let i = 0; i < elements.length; i++) {
        checkAndLoad(elements[i]);
      }
    }
  }

  // Initial scan
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scan(document.body);
    });
  } else {
    scan(document.body);
  }

  // Listen for dynamic DOM updates (AJAX loads, drawer openings, theme editor changes)
  const observer = new MutationObserver((mutations) => {
    for (let i = 0; i < mutations.length; i++) {
      const added = mutations[i].addedNodes;
      for (let j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) {
          scan(added[j]);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Handle conditional polyfills
  if (!('popover' in HTMLElement.prototype)) {
    import('@theme/popover-polyfill').catch(err => console.error('[LazyLoader] Failed to load popover polyfill:', err));
  }
})();
